export default function Tilgaengelighed() {
  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-extrabold text-slate-900 mb-8">Tilgængelighedserklæring</h1>

        <div className="prose prose-slate max-w-none">
          <p className="text-sm text-slate-600 mb-8">
            <strong>Senest opdateret:</strong> 30. oktober 2025
          </p>

          <div className="bg-brand-50 border border-brand-200 rounded-lg p-6 mb-8">
            <p className="text-brand-900 font-semibold mb-2">
              Plejesøstrene ApS er forpligtet til at gøre vores hjemmeside tilgængelig i overensstemmelse med lov om tilgængelighedskrav for produkter og tjenester.
            </p>
            <p className="text-sm text-brand-800">
              (Implementering af Europa-Parlamentets og Rådets direktiv 2019/882/EU - European Accessibility Act)
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Vores forpligtelse</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Plejesøstrene ApS bestræber sig på at sikre, at vores hjemmeside plejesoestrene.dk er tilgængelig for alle brugere, uanset hjælpemidler eller evner.
            </p>
            <p className="text-slate-700 leading-relaxed">
              Vi arbejder løbende på at forbedre tilgængeligheden og brugervenligheden af vores hjemmeside for at sikre, at alle kan få adgang til information og tjenester.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Overholdelsesniveau</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Denne hjemmeside bestræber sig på at være:
            </p>
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4">
              <p className="text-amber-900">
                <strong>Delvist compliant</strong> med Web Content Accessibility Guidelines (WCAG) 2.1 Level AA
              </p>
            </div>
            <p className="text-slate-700 leading-relaxed text-sm">
              "Delvist compliant" betyder, at nogle dele af indholdet ikke fuldt ud overholder WCAG 2.1 Level AA-standarden.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Tekniske specifikationer</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Hjemmesidens tilgængelighed afhænger af følgende teknologier til at arbejde med browser og assistive teknologier på din computer:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li>HTML5</li>
              <li>CSS3</li>
              <li>JavaScript (React framework)</li>
              <li>WAI-ARIA (Accessible Rich Internet Applications)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Tilgængelighedsfunktioner</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Hjemmesiden inkluderer følgende tilgængelighedsfunktioner:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li>Struktureret overskriftshierarki for skærmlæsere</li>
              <li>Alternativ tekst (alt-tags) på informative billeder</li>
              <li>Tastaturnavigation mulig på alle interaktive elementer</li>
              <li>Formularer med tydeligt mærkede felter</li>
              <li>Responsivt design der fungerer på forskellige enheder</li>
              <li>Tydelige fokusindikatorer ved tastaturnavigation</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Kendte begrænsninger</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              På trods af vores bedste indsats kan der være områder af hjemmesiden, som endnu ikke er fuldt tilgængelige.
              Vi er opmærksomme på følgende begrænsninger og arbejder på at løse dem:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li>Visse dekorative elementer kan mangle beskrivende ARIA-labels</li>
              <li>Farvkontrasten på nogle sekundære elementer opfylder muligvis ikke 4.5:1-kravet</li>
              <li>Komplekse animationer kan ikke altid deaktiveres</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mt-4">
              Vi arbejder kontinuerligt på at forbedre tilgængeligheden af hele hjemmesiden.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Vurdering og testning</h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3">Vurderingsmetode</h3>
            <p className="text-slate-700 leading-relaxed mb-4">
              Denne erklæring er baseret på:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4">
              <li>Selvvurdering udført af Plejesøstrene ApS</li>
              <li>Automatiseret testning med værktøjer som WAVE og Lighthouse</li>
              <li>Manuel testning med tastaturnavigation</li>
            </ul>

            <h3 className="text-xl font-semibold text-slate-900 mb-3">Vurderingsdatoer</h3>
            <p className="text-slate-700 leading-relaxed">
              <strong>Seneste vurdering:</strong> 30. oktober 2025<br />
              <strong>Næste planlagte vurdering:</strong> 30. april 2026
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Feedback og kontakt</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Vi ønsker at høre fra dig, hvis du oplever tilgængelighedsproblemer på vores hjemmeside.
            </p>

            <div className="bg-slate-50 border border-slate-200 rounded-lg p-6 mb-4">
              <h3 className="text-lg font-semibold text-slate-900 mb-3">Rapporter et tilgængelighedsproblem</h3>
              <p className="text-slate-700 mb-3">
                Hvis du støder på barrierer eller har forslag til forbedringer, kontakt os venligst:
              </p>
              <p className="text-slate-700">
                <strong>Email:</strong> <a href="mailto:info@plejesoestrene.dk" className="text-brand-600 hover:underline">info@plejesoestrene.dk</a><br />
                <strong>Telefon:</strong> <a href="tel:+4589801515" className="text-brand-600 hover:underline">89801515</a><br />
                <strong>Post:</strong> Helgavej 26, 5230 Odense M
              </p>
            </div>

            <p className="text-slate-700 leading-relaxed">
              Vi bestræber os på at besvare henvendelser om tilgængelighed inden for <strong>5 arbejdsdage</strong>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Håndhævelse</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Hvis du ikke er tilfreds med vores håndtering af din tilgængelighedsklage, eller hvis du mener, at vi ikke overholder tilgængelighedskravene, kan du kontakte den relevante tilsynsmyndighed:
            </p>

            <div className="bg-slate-50 border border-slate-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-slate-900 mb-3">Sikkerhedsstyrelsen</h3>
              <p className="text-slate-700">
                Markedstilsynsenheden<br />
                Lautrupvang 1A<br />
                2750 Ballerup<br />
                <strong>Email:</strong> <a href="mailto:sikkerhedsstyrelsen@sik.dk" className="text-brand-600 hover:underline">sikkerhedsstyrelsen@sik.dk</a><br />
                <strong>Telefon:</strong> 33 73 50 00<br />
                <strong>Website:</strong> <a href="https://www.sik.dk" target="_blank" rel="noopener noreferrer" className="text-brand-600 hover:underline">www.sik.dk</a>
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Alternative formater</h2>
            <p className="text-slate-700 leading-relaxed">
              Hvis du har brug for information fra denne hjemmeside i et alternativt format (f.eks. stor skrift, lyd, andet format),
              kontakt os venligst, så vil vi bestræbe os på at imødekomme dit behov.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Standards og retningslinjer</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Denne tilgængelighedserklæring og hjemmesidens tilgængelighedsindsats følger:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li><strong>WCAG 2.1</strong> - Web Content Accessibility Guidelines (W3C)</li>
              <li><strong>EN 301 549</strong> - Europæisk standard for tilgængelighed af IKT-produkter og -tjenester</li>
              <li><strong>Direktiv 2019/882/EU</strong> - European Accessibility Act</li>
              <li><strong>Dansk implementering</strong> - Lov om tilgængelighedskrav for produkter og tjenester</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Løbende forbedringer</h2>
            <p className="text-slate-700 leading-relaxed">
              Vi gennemgår regelmæssigt vores hjemmeside for at identificere og løse tilgængelighedsproblemer.
              Tilgængelighed er en løbende proces, og vi er forpligtede til at sikre, at vores hjemmeside forbliver tilgængelig for alle brugere.
            </p>
          </section>

          <div className="mt-12 pt-8 border-t border-slate-200">
            <p className="text-sm text-slate-600 mb-3">
              <strong>Yderligere ressourcer:</strong>
            </p>
            <ul className="list-disc pl-6 text-sm text-slate-600 space-y-1">
              <li><a href="https://www.w3.org/WAI/" target="_blank" rel="noopener noreferrer" className="text-brand-600 hover:underline">Web Accessibility Initiative (WAI)</a></li>
              <li><a href="https://www.sik.dk" target="_blank" rel="noopener noreferrer" className="text-brand-600 hover:underline">Sikkerhedsstyrelsen - Markedstilsyn</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 text-center">
          <a
            href="/"
            className="btn btn-primary btn-lg"
          >
            Tilbage til hjemmesiden
          </a>
        </div>
      </div>
    </div>
  );
}
